import React from "react"

import {
    ContentPreviewElementProps,
    ContentPreviewElementState,
} from "./models"

import {
    Box, Popper
} from "@mui/material"

import "./style.scss"

import { ContentPreviewElementPopup } from "./content-preview-element-popup/content-preview-element-popup"
import { Trans } from "@lingui/macro"
import { SegregationType } from "commons/form-constants"

export class ContentPreviewElement extends React.Component<ContentPreviewElementProps, ContentPreviewElementState> {

    constructor(props: Readonly<ContentPreviewElementProps> | ContentPreviewElementProps) {

        super(props);

        this.state = {
            showOverlay: false
        };
    }

    private previewElementRef: any;

    showOverlay = () => {
        if (!this.props.disablePopupOverlay)
            this.setState(() => ({ showOverlay: true }));
    };

    hideOverlay = () => {
        if (!this.props.disablePopupOverlay)
            this.setState(() => ({ showOverlay: false }));
    };

    private isInViewportHorizontally = (offset = 0) => {
        if (!this.previewElementRef) return false;
        const rigthBoundary = this.previewElementRef.getBoundingClientRect().right;
        return (rigthBoundary + offset) >= 0 && (rigthBoundary - offset) <= window.innerWidth;
    }

    render() {

        const hideOverlay = () => {
            this.hideOverlay()
        }

        return (
            <>
                <Box
                    sx={
                        { width: "300px", display: "inline-flex", position: "relative", mx: this.props.hasHorizontalMargin ? 1 : undefined }
                    }
                    onMouseOver={this.showOverlay}
                    className="cpe-main">
                    <img
                        ref={(el) => this.previewElementRef = el}
                        src={process.env.REACT_APP_API_CLOUDFRONT_DISTRIBUTION_URL + this.props.content?.thumbnailData.thumbnailS3Key!}
                        alt={"Content preview"}
                        style={{ width: "300px", height: "169px", objectFit: "cover" }} />
                    {this.props.content.segregationType === SegregationType.PAY_PER_VIEW && <Box sx={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        backgroundColor: process.env.REACT_APP_PRIMARY_COLOR,
                        fontWeight: "bold",
                        paddingLeft: "5px",
                        paddingBottom: "5px",
                        paddingRight: "15px",
                        borderBottomRightRadius: "100%",
                        color: process.env.REACT_APP_SECONDARY_COLOR
                    }}>
                        €
                    </Box>}

                    {this.props.content.segregationType === SegregationType.SUBSCRIPTION && <Box sx={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        backgroundColor: process.env.REACT_APP_PRIMARY_COLOR,
                        fontWeight: "bold",
                        paddingLeft: "5px",
                        paddingBottom: "5px",
                        paddingRight: "20px",
                        borderBottomRightRadius: "100%",
                        color: process.env.REACT_APP_SECONDARY_COLOR
                    }}>
                        <Trans id="cpe-subscription-shorthand"> ABB </Trans>
                    </Box>}

                    {(this.isInViewportHorizontally() && this.state.showOverlay && !this.props.disablePopupOverlay) && <Box onMouseLeave={this.hideOverlay} style={{
                        position: "absolute",
                        justifyContent: "center",
                        visibility: (this.isInViewportHorizontally() && this.state.showOverlay) ? "visible" : "hidden",
                        opacity: (this.isInViewportHorizontally() && this.state.showOverlay) ? 1 : 0,
                        transition: "visibility 0.1s ease-out, opacity 0.4s ease-in",
                        zIndex: 999,
                        top: "-25%",
                        left: "-30px"
                    }}>

                    </Box>}
                    {<Box onMouseLeave={this.hideOverlay} style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        backgroundColor: process.env.REACT_APP_PRIMARY_COLOR,
                        width: "300px",
                        height: "169px",
                        justifyContent: "center",
                        visibility: (!this.isInViewportHorizontally() && this.state.showOverlay) ? "visible" : "hidden",
                        opacity: (!this.isInViewportHorizontally() && this.state.showOverlay) ? 0.6 : 0,
                        transition: "visibility 0.1s ease-out, opacity 0.4s ease",
                        zIndex: 99,
                    }}></Box>}
                </Box>
                {<Popper anchorEl={this.previewElementRef} modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [-50, -220],
                        },
                    }
                ]} open={(this.state.showOverlay && this.isInViewportHorizontally())}>
                    <ContentPreviewElementPopup hideOverlay={hideOverlay} content={this.props.content} />
                </Popper>}
            </>);
    }

}
